import { injectable } from 'inversify';
import { Component } from '../../../concepts/objects';
import { LensAspect } from '../lens/LensAspect';
import { LensAspectProvider } from '../lens/LensAspectProvider';
import { Voter } from './Voter';

const staticAspects = [
    LensAspect.create(
        'VoteItem[]',
        'Voter.winners',
        'winners',
        'The VoteItems that were most voted for.',
        'property',
        (elmt: Component) => {
            return elmt.as(Voter)?.winners;
        }
    ),
    LensAspect.create(
        'string[]',
        'Voter.winnerValues',
        'winnerValues',
        'The values of the VoterItems that were most voted for.',
        'property',
        (elmt: Component) => {
            return elmt.as(Voter)?.winners?.map(x => x.text);
        }
    ),
];

@injectable()
export class VoterLensAspectProvider implements LensAspectProvider {

    public getAspectsFor(elmts: Component[]): LensAspect[] {
        if (!elmts.some(x => x.is(Voter))) return [];
        return staticAspects;
    }
}
